import Vue from "vue";
import { Core } from "~/core/Core";

async function loginADToken(ctx: any) {
  let adToken = ctx.$route?.query?.token;
  let appID = ctx.$route?.query?.application_id;
  if (adToken) {
    try {
      const res = await ctx.$auth.loginADTokenLoader(ctx, adToken, appID)
      return;
    }
    catch (err) {
    }
  }
}

export default {
  loginADToken,
};
